/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import {
  UilBuilding,
  UilClock,
  UilEnvelopeAlt,
  UilGift,
  UilPhone,
  UilPostcard,
  UilWhatsapp,
  UilLockAccess
} from '@iconscout/react-unicons';
import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import EmployeeInfoItem from './EmployeeInfoItem';
import { formatDate } from 'services/utils';
import ChangeLocationPopover from 'views/hrms/driver/driver-detail/ChangeLocationPopover';
import Button from 'components/base/Button';
import { useState } from 'react';
import ResetPinModal from '../ResetPineModal';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import apiEndpoints from 'constants/apiEndpoints';
import { useLoading } from 'providers/PageLoadingProvider';
import { useAuth } from 'hooks/auth/useAuth';

const AboutEmployeeCard = ({ className, data }) => {
  const {
    date_of_birth,
    employee_unique_id,
    education,
    employee_email,
    employee_mobile,
    employee_whatsapp_number,
    employee_id,
    first_name,
    role_name,
    employee_role,
    login_pin,
    trans_pin
  } = data.personal_information || {};
  const { loc_area_name, loc_area_id, shift_name } =
    data.professional_details || {};
  const [pinChange, setPinChange] = useState(false);
  const [pinName, setPinName] = useState('');
  const [pinNo, setPinNo] = useState('');
  const [loginPinNo, setLoginPinNo] = useState(1234);
  const [transPinNo, setTransPinNo] = useState(7890);
  const [loading, setLoading] = useState(false);
  const { manageLoading } = useLoading();
  const { showAlert } = useAlert();
  const { user } = useAuth();
  console.log('🚀 ~ AboutEmployeeCard ~ user:', user);
  const handleChangePin = (name, pin) => {
    setPinName(name);
    setPinNo(pin);
    setPinChange(true);
  };
  const handlePinSubmit = async (pinType, pinNo, confirmPin) => {
    manageLoading(true, 'Reset password...');
    const endpoint =
      pinType === 'loginPin'
        ? apiEndpoints.auth.resetEmployeeLoginPin
        : apiEndpoints.auth.resetEmployeeTransPin;

    const requestData =
      pinType === 'loginPin'
        ? {
            new_login_pin: pinNo,
            new_login_pin_confirmation: confirmPin,
            user_id: employee_id
          }
        : {
            new_transaction_pin: pinNo,
            new_transaction_pin_confirmation: confirmPin,
            user_id: employee_id
          };
    const requestStatus = await postData(requestData, endpoint);
    manageLoading(false);
    if (requestStatus.status) {
      setPinChange(false);
      showAlert({
        variant: 'success',
        message: `${pinType === 'loginPin' ? 'Login' : 'Transaction'} PIN reset successfully.`
      });
    } else {
      // setIsPinCorrect(false);
      // pinRef?.clear();
      // setPin('');
      showAlert({
        variant: 'danger',
        message: `Failed to reset PIN: ${requestStatus.message}`
      });
    }
  };
  return (
    <>
      <Card className={classNames(className)}>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-5">
            <h3>About {first_name}</h3>
          </div>
          <EmployeeInfoItem
            className="mb-4"
            label="Employee Id"
            icon={UilPostcard}
          >
            <p className="mb-0 text-800">{employee_unique_id || '--'}</p>
          </EmployeeInfoItem>

          <EmployeeInfoItem
            className="mb-4"
            label="Email"
            icon={UilEnvelopeAlt}
          >
            <Link to="mailto:ansolo5@jeemail.com">
              {employee_email || '--'}
            </Link>
          </EmployeeInfoItem>
          <EmployeeInfoItem className="mb-4" label="Phone" icon={UilPhone}>
            <Link to="tel:+91 9876543210">{employee_mobile}</Link>
          </EmployeeInfoItem>
          <EmployeeInfoItem
            className="mb-4"
            label="Whatsapp Number"
            icon={UilWhatsapp}
          >
            <a
              target="_blank"
              rel={'noreferrer'}
              href="https://wa.me/+91 9876543210"
            >
              {employee_whatsapp_number || '--'}
            </a>
          </EmployeeInfoItem>
          <EmployeeInfoItem
            className="mb-4"
            label="Education"
            icon={UilPostcard}
          >
            <p className="mb-0 text-800">{education || '--'}</p>
          </EmployeeInfoItem>
          <EmployeeInfoItem
            className="mb-4"
            label="Date Of Birth"
            icon={UilGift}
          >
            <p className="mb-0 text-800">{`${formatDate(date_of_birth, 'DD MMM YYYY') || '--'}`}</p>
          </EmployeeInfoItem>
          <EmployeeInfoItem
            className="mb-4"
            label="Working Location"
            icon={UilBuilding}
          >
            <div className="d-flex align-items-end">
              <p className="mb-0 text-800">{loc_area_name || '--'}</p>
            </div>
          </EmployeeInfoItem>
          <EmployeeInfoItem className="mb-4" label="Shift" icon={UilClock}>
            <p className="mb-0 text-800">{shift_name || '--'}</p>
          </EmployeeInfoItem>

          {(user?.user_role === 'Admin' ||
            user?.user_role === 'SuperAdmin') && (
            <EmployeeInfoItem
              className="mb-4"
              label="Change Pin"
              icon={UilLockAccess}
            >
              <Button
                onClick={() => handleChangePin('loginPin', loginPinNo)}
                variant="link"
                className="p-0 fs-10 ms-3 pe-2"
              >
                Change Login Pin
              </Button>
              <Button
                onClick={() => handleChangePin('transPin', transPinNo)}
                variant="link"
                className="p-0 fs-10 ps-2 border-start border-300 rounded-0"
              >
                Change Trans Pin
              </Button>
              {/* {role_name == 'Payer' && (
              )} */}
            </EmployeeInfoItem>
          )}
          {/* {employee_role == 'Payer' && (
            <EmployeeInfoItem
              className="mb-4"
              label="Change Transaction Pin"
              icon={UilClock}
            >
              <Button
                onClick={() => handleChangePin('transPin', transPinNo)}
                variant="link"
                className="p-0 fs-10 ms-3"
              >
                Change
              </Button>{' '}
            </EmployeeInfoItem>
          )} */}
        </Card.Body>
      </Card>
      {pinChange && (
        <ResetPinModal
          show={pinChange}
          handleClose={() => setPinChange(false)}
          pinType={pinName}
          pinNo={''}
          onSubmit={handlePinSubmit}
        />
      )}
    </>
  );
};

export default AboutEmployeeCard;
